import { CertificateType } from '@lib/core/enum';
import { BaseProfile, BaseUser } from '@lib/core/model';
import { Uuid } from '@lib/core/type';
import { WorkerItem } from '@proget-shared/grid/grid-actions';
import { SelectableItem } from '@proget-shared/grid/selection';
import { TableRow } from '@proget-shared/grid/table';

import { UserCertificateStatus } from '../enum/user-certificate-status.enum';

import { Certificate } from './certificate';

export class UserCertificate implements WorkerItem, SelectableItem, TableRow {
  public readonly expired: boolean;
  public readonly revoked: boolean;

  constructor(
    public readonly id: Uuid,
    public readonly purpose: string,
    public readonly certificate: Certificate,
    public readonly user: BaseUser,
    public readonly profileCertificate: BaseProfile | null,
    public readonly signingCertificateName: string,
    public readonly status: UserCertificateStatus,
    public readonly profileCertificateType: CertificateType
  ) {
    this.expired = !this.certificate.valid;
    this.revoked = status === UserCertificateStatus.REVOKED;
  }

  getId(): Uuid {
    return this.id;
  }

  getDisplayName(): string {
    return [
      this.user.fullName,
      this.profileCertificate?.name,
      this.certificate?.validity,
    ].filter(Boolean).join(' - ');
  }

  getSelectionId(): Uuid {
    return this.id;
  }

  isExpandable(): boolean {
    return !!this.certificate;
  }
}
